import axios from "axios";

//Deploy
//const baseURL = "https://api.flight-times-gti.com/api/v1"; //PROD
//const baseURL = "https://uatapi.flight-times-gti.com/api/v1"; //UAT
const baseURL = "https://api.dev-raiden.com/api/v1"; //DEV
//const baseURL = "http://localhost:3000/api/v1"; //DEV LOCAL

//Deploy (For UAT environment only - to be removed for PROD)
//Replace all <nav class="bg-red-700"> tags with <nav class="bg-red-700">

const api = axios.create({
  baseURL,
  timeout: 20000,
});

api.interceptors.response.use(
  (response) => {
    // Any status code within the range of 2xx triggers this function
    return response;
  },
  (error) => {
    // Any status codes outside the range of 2xx trigger this function
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          console.error("Unauthorized: Logging user out...");
          // Redirect to login or clear local storage
          break;
        case 403:
          console.error("Forbidden: You do not have permission.");
          break;
        case 404:
          console.error("Not Found: The resource does not exist.");
          break;
        case 500:
          console.error("Server Error: Please try again later.");
          break;
        default:
          console.error(
            `Error ${status}:`,
            data.message || "An error occurred"
          );
      }
    } else if (error.request) {
      // The request was made but no response was received (e.g., your 20s timeout)
      console.error("Network error or timeout. No response from server.");
    } else {
      // Something happened in setting up the request
      console.error("Request Error:", error.message);
    }

    return Promise.reject(error);
  }
);

export default api;
